import { ExclamationBrown } from '@icons';
import React, { ReactNode } from 'react';
import { Button, Modal } from 'react-bootstrap';

interface ConfirmModalProps {
    title: ReactNode
    message: ReactNode;
    show: boolean;
    onHide: () => void;
    callback: () => void;
    confirmButtonLabel: ReactNode;
    confirmButtonClassName?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ title, message, show, onHide, callback, confirmButtonLabel, confirmButtonClassName = "custom-primary-button" }) => {
    return <Modal
        show={show}
        onHide={() => {
            onHide();
        }}
        centered
        className="supermodal"
        backdropClassName="supermodal-backdrop"
    >
        <Modal.Header
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px',
            }}
        >
            <ExclamationBrown fill="#1C2743" style={{ margin: '8px', width: "40px", height: "40px" }} />
            <h3
                style={{
                    fontSize: '24px',
                    textAlign: 'center',
                    lineHeight: '35px',
                    marginBottom: 0,
                    fontWeight: 700,
                }}
            >
                {title}
            </h3>
        </Modal.Header>
        <Modal.Body
            style={{
                padding: '0 16px',
            }}
        >
            <p
                style={{
                    textAlign: 'center',
                    marginBottom: 0,
                    lineHeight: '28px',
                }}
            >
                {message}
            </p>
        </Modal.Body>
        <Modal.Footer style={{ display: 'flex', padding: '16px', flexWrap: 'nowrap', marginTop: '48px' }}>
            <Button
                className="btn custom-outline-button"
                style={{
                    width: '100%',
                    height: '48px',
                }}
                onClick={() => {
                    onHide();
                }}
            >
                Annulla
            </Button>
            <Button
                className={`btn ${confirmButtonClassName}`.trim()}
                style={{
                    width: '100%',
                    height: '48px',
                }}
                onClick={() => {
                    callback();
                    onHide();
                }}
            >
                {confirmButtonLabel}
            </Button>
        </Modal.Footer>
    </Modal>
}

export default ConfirmModal